














































































































import {
  createComponent,
  inject,
  computed,
  onMounted,
  ref,
  SetupContext
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import MemberCloseAccountKey from "@/components/member-close-account-key";
import _ from "lodash";

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const displayuiStore = inject(DisplayUIKey);
    if (!displayuiStore) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }

    const memberCloseAccountStore = inject(MemberCloseAccountKey);
    if (!memberCloseAccountStore) {
      throw new Error(`${MemberCloseAccountKey} is not provided`);
    }

    const globalStore = context.root.$store;
    const accessToken = computed(() => globalStore.auth.token);

    const response = computed(() => memberCloseAccountStore.response);

    const displayParams = computed(
      () => memberCloseAccountStore.displayParams
    );
    const displayError = computed(
      () => memberCloseAccountStore.displayError
    );
    const displayErrorFlag = computed(
      () => memberCloseAccountStore.displayErrorFlag
    );

    // 確認ボタンがクリック済みかどうか
    const isConfirmButtonClicked = ref(false);

    onMounted(async () => {
      memberCloseAccountStore.setAuthorizationHeader(accessToken.value);
    });

    return {
      // view parameter
      displayParams,
      displayError,
      displayErrorFlag,

      // input
      inputCloseAccountParamsName1(e: any) {
        memberCloseAccountStore.inputDisplayParams(e,'name_1');
        if (isConfirmButtonClicked.value) {
          memberCloseAccountStore.validateDisplayParams();
        }
      },
      inputCloseAccountParamsName2(e: any) {
        memberCloseAccountStore.inputDisplayParams(e,'name_2');
        if (isConfirmButtonClicked.value) {
          memberCloseAccountStore.validateDisplayParams();
        }
      },
      inputCloseAccountParamsBirthday(e: any) {
        memberCloseAccountStore.inputDisplayParams(e,'birthday');
        if (isConfirmButtonClicked.value) {
          memberCloseAccountStore.validateDisplayParams();
        }
      },
      inputCloseAccountParamsCloseReason(e: any) {
        memberCloseAccountStore.inputDisplayParams(e,'close_reason');
        if (isConfirmButtonClicked.value) {
          memberCloseAccountStore.validateDisplayParams();
        }
      },

      confirm() {
        isConfirmButtonClicked.value = true;

        if (!memberCloseAccountStore.validateDisplayParams()) {
          displayuiStore.showErrorSnackBar("入力内容を確認してください。");
          return;
        }

        context.root.$router.push({ name: "MemberPersonalCloseAccountConfirm" });
      }
    };
  },
  components: {
    
  }
});
